import {Component, Inject} from "ng-metadata/core";

@Component({
    selector: 'prm-no-sign-in-available-popup',
    templateUrl: 'components/security/login/no-sign-in-available-popup.html',
})
export class PrmNoSignInAvailablePopup {
    constructor(
        @Inject('$mdDialog') private $mdDialog: ng.material.IDialogService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService
    ) {}

    public closePopup() {
        this.$mdDialog.cancel();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/no-sign-in-available-popup.ts